<template>
  <qx-card title="证照记录" class="detail">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='vehicleServiceBO.ajax?cmd=queryVehicleCertificatesInsurance'
          :params="fullSearchData"
          bizName="车辆证照记录导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>

    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <!-- <section slot-scope="scope"></section> -->
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total || 0"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import ExportBtn from 'components/exportBtn';
import tableMixin from '@qx/mixin/table';
import {
  queryVehicleCertificatesInsurance,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  prop: {
    vehicleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ExportBtn,
  },
  data () {
    return {
      searchBoxData: {
        vehicleCode: this.$route.query.id || -1,
        flg: '2',
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'certificatesInsuranceTypeName',
            label: '证照类型',
          },
          {
            prop: 'certificatesInsuranceFee',
            label: '金额(元)',
          },
          {
            prop: 'userName',
            label: '经办人',
          },
          {
            prop: 'userTel',
            label: '经办人电话',
          },
          {
            prop: 'handleDate',
            label: '办理时间',
          },
          {
            prop: 'insuranceStartDate',
            label: '生效日期',
          },
          {
            prop: 'insuranceEndDate',
            label: '到期日期',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryVehicleCertificatesInsurance,
  },
};
</script>

<style>
</style>
